const Input = ({
  type = 'text',
  ref,
  ...props
}: React.ComponentPropsWithRef<'input'>) => {
  const { className, ...otherProps } = props
  return (
    <input
      ref={ref}
      className={`peer-focus:text-sky peer block min-h-auto rounded border-2 bg-transparent px-3 py-[0.32rem] leading-[1.6] transition-all duration-200 ease-linear outline-none focus:border-sky-300 focus:placeholder:opacity-100 data-te-input-state-active:placeholder:opacity-100 motion-reduce:transition-none ${className}`}
      type={type}
      {...otherProps}
    />
  )
}

export default Input
